import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// The Segoe editor fonts are only needed in the personalize/create editor, NOT on browse — and the
// two TTFs were ~6.5s on the critical path because the whole app waited on them before first paint
// (store-home perf, audit 2026-06-26). Load them in the BACKGROUND with `display: 'swap'` so text
// paints immediately in a fallback and swaps when the font arrives; never block render.
const loadFonts = async () => {
  if (typeof FontFace === 'undefined' || !document.fonts) return;
  try {
    const segoeScriptFont = new FontFace(
      'Segoe Script',
      `url(${process.env.PUBLIC_URL || ''}/fonts/Segoe%20Script.ttf) format('truetype')`,
      { display: 'swap' }
    );
    const segoeFont = new FontFace(
      'Segoe',
      `url(${process.env.PUBLIC_URL || ''}/fonts/segoe.ttf) format('truetype')`,
      { display: 'swap' }
    );
    const loaded = await Promise.all([segoeScriptFont.load(), segoeFont.load()]);
    loaded.forEach((font) => document.fonts.add(font));
  } catch (error) {
    console.warn('Failed to load custom fonts:', error);
  }
};

// Render immediately — do not await fonts.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Kick off editor-font loading in the background after first paint.
loadFonts();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
